import React from 'react';
import { Location } from '@reach/router';
import queryString from 'query-string';

export type WithUrlProps = {
    location: any
    navigate: any
    search: any
    setHash: Function
}

const withLocation = (Component: any, props: any) => {
    const LocationComponent = Location as any

    return (
        <LocationComponent>
            {({ location, navigate }: any) => {
                const withUrlProps: WithUrlProps = {
                    location,
                    navigate,
                    search: location.search
                        ? queryString.parse(location.search)
                        : {},
                    /**
                     * Att present, mutating location hash causes a page-wide rerender,
                     * this function allows for this without said rerender. Although,
                     * consumers of this HOC are not able to use
                     * useEffect(..., [props.location]), so if setHash() is used,
                     * side-effects will have to be handleded another way
                     */
                    setHash: (hash: string) => {
                        window &&
                            (window.history as any).pushState(null, null, hash)
                    },
                }

                return (
                    <div>
                        <Component {...props} {...withUrlProps} />
                    </div>
                );
            }}
        </LocationComponent>
    );
}

export default withLocation;
